/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Education_In_GradInputs */

const en_onboarding_education_in_grad = /** @type {(inputs: Onboarding_Education_In_GradInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currently in grad school`)
};

const es_onboarding_education_in_grad = /** @type {(inputs: Onboarding_Education_In_GradInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualmente en posgrado`)
};

/**
* | output |
* | --- |
* | "Currently in grad school" |
*
* @param {Onboarding_Education_In_GradInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_education_in_grad = /** @type {((inputs?: Onboarding_Education_In_GradInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Education_In_GradInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_education_in_grad(inputs)
	return en_onboarding_education_in_grad(inputs)
});